import { jsx as _jsx } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
const Anchor = ({ width, children, }) => (_jsx("div", { style: {
        height: 18,
        color: 'white',
        width,
        backgroundColor: 'rgb(24, 170, 177)',
    }, children: children }));
const node = (_jsx("div", { style: {
        backgroundColor: '#ae0d5c',
        color: 'white',
        minHeight: 18,
    }, children: Array(10).fill('Lorem ipsum dolor sit amet.').join(' ') }));
export default function FitOnPage() {
    return (_jsx(Regression, { allBrowsers: true, version: "1.0.0", fixed: true, title: "Fit on page", description: "Stick nodes should always fit into the page and never cause a horizontal scrollbar to appear, even after resize", children: _jsx("div", { style: { display: 'inline-block', width: '90%' }, children: _jsx(Stick, { position: "bottom right", node: node, children: _jsx(Anchor, {}) }) }) }));
}
